@for (task of tasks; track task; let index = $index) {
  <div
    class="flex cursor-pointer items-center justify-between px-3 py-4 hover:bg-aux-blue-light-50"
    [ngClass]="{
      'bg-aux-gray-light': index % 2 === 0,
    }"
    (click)="navigateToTask(task)"
  >
    <div>
      <p>{{ task.task_header }}</p>
      <p class="text-sm">{{ task.trial_name }}</p>
      @if (task.organization_name) {
        <p class="text-sm">Vendor Contract: {{ task.organization_name }}</p>
      }
    </div>
    <div class="flex items-center">
      <div>
        <p class="text-right text-sm">{{ task.create_date | timeago }}</p>
      </div>
      <aux-icon name="ChevronRight" class="ml-3 text-aux-blue" />
    </div>
  </div>
}

@if (!tasks.length) {
  <div class="flex h-full flex-col items-center justify-center">
    <span class="ml-3 text-aux-blue">
      <!-- todo stroke-linecap="round" stroke-linejoin="round" -->
      <aux-icon name="Check" class="stroke-[10px] text-aux-gray-dark" />
    </span>
    <p class="mt-4 text-sm text-aux-gray-darkest">{{ noTasksMessage }}</p>
  </div>
}
